import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { DomSanitizer } from '@angular/platform-browser';
import { API_BASE_URL_SERVICE } from '../../../kiene-core.config';
import { KieneBackendApiService } from '../../../services/backend-api/kiene-backend-api.service';
import { MessageService } from '../../../services/message-service/message.service';
import { ConfirmDialogInput, ConfirmDialogResult } from '../../dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { UserRole } from '../../stammdaten/benutzer/benutzer';
import { HilfeReiter } from '../Hilfe';

export class EditHilfeDialogResult {
    hilfeReiter: HilfeReiter;
    confirm: boolean;
}

@Component({
    selector: 'kiene-edit-hilfe-dialog',
    templateUrl: './edit-hilfe-dialog.component.html',
    styleUrls: ['./edit-hilfe-dialog.component.scss'],
})
export class EditHilfeDialogComponent implements OnInit {
    roles: UserRole[] = [];
    titelCtrl: FormControl = new FormControl();
    benutzerrollenCtrl: FormControl = new FormControl();
    hilfeseiteUrlCtrl: FormControl = new FormControl();

    constructor(
        public dialogRef: MatDialogRef<EditHilfeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public hilfereiter: HilfeReiter,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private dialog: MatDialog,
        private api: KieneBackendApiService,
        private messageService: MessageService,
        private sanitizer: DomSanitizer,
    ) {}

    ngOnInit(): void {
        if (this.hilfereiter.titel) {
            this.titelCtrl.setValue(this.hilfereiter.titel);
        }
        if (this.hilfereiter.benutzerrollen) {
            this.benutzerrollenCtrl.setValue(this.hilfereiter.benutzerrollen);
        }
        if (this.hilfereiter.hilfeseite_url) {
            this.hilfeseiteUrlCtrl.setValue(this.hilfereiter.hilfeseite_url);
        }
        this.ladeRoles();
    }

    public deleteHilfeReiter(): void {
        const input = new ConfirmDialogInput();
        input.headline = 'Hilfeseite löschen';
        input.text = 'Möchten Sie die Hilfeseite wirklich löschen?';

        this.dialog
            .open(ConfirmDialogComponent, { data: input })
            .afterClosed()
            .subscribe({
                next: (confirmResult: ConfirmDialogResult) => {
                    if (confirmResult.confirmed) {
                        const result: EditHilfeDialogResult = new EditHilfeDialogResult();
                        result.confirm = true;
                        result.hilfeReiter = undefined;
                        this.dialogRef.close(result);
                    }
                },
            });
    }

    public close(): void {
        const result: EditHilfeDialogResult = new EditHilfeDialogResult();
        result.confirm = false;
        this.dialogRef.close(result);
    }

    public save(): void {
        const result: EditHilfeDialogResult = new EditHilfeDialogResult();
        result.hilfeReiter = this.hilfereiter;

        result.hilfeReiter.sichereUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            result.hilfeReiter.hilfeseite_url,
        );
        result.hilfeReiter.showIframe = true;
        result.confirm = true;
        console.log(result);
        this.dialogRef.close(result);
    }

    private ladeRoles(): void {
        this.api.getAll(this.apiBaseUrl + 'benutzerrolle/read.php').subscribe({
            next: response => {
                if (response && response.records) {
                    this.roles = response.records;
                }
            },
            error: error => {
                this.messageService.errorMessage('Benutzerrollen konnten nicht geladen werden!', error);
            },
        });
    }

    public setRollen(event: MatSelectChange): void {
        this.hilfereiter.benutzerrollen = event.value;
    }

    public compareRoles(role1: UserRole, role2: UserRole): boolean {
        return role1 && role2 && role1.benutzerrolle_id === role2.benutzerrolle_id;
    }

    public setTitel(): void {
        this.hilfereiter.titel = this.titelCtrl.value;
    }

    setUrl(): void {
        let url = this.hilfeseiteUrlCtrl.value;

        if (typeof url !== 'string') {
            this.messageService.alertMessage('Ungültige URL! Bitte geben Sie eine gültige URL ein.');
            return;
        }

        if (!url.startsWith('http')) {
            url = 'https://' + url;
        }

        this.hilfereiter.hilfeseite_url = url;
        this.hilfereiter.sichereUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
        this.hilfereiter.showIframe = true;
    }

    public isDisabled(): boolean {
        return !this.titelCtrl.value || !this.benutzerrollenCtrl.value || !this.hilfeseiteUrlCtrl.value;
    }
}
